import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import LoginHistory from "../../features/manageUsers/loginHistory";
import TransactionHistory from "../../features/manageUsers/transctionHistory";
import ReferralHistory from "../../features/manageUsers/refferalHistory";
import UserAuditLogTable from "../../features/manageUsers/userAuditLogTable";
import AdjustedPointsTable from "../../features/manageUsers/adjustedPointsTable";
import VerificationModal from "../../Modals/verificationModal";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";
import {
  useGetUsersByIdQuery,
  useGetUserTransactionsQuery,
} from "../../services/user";
import dayjs from "dayjs";
import usePermission from "../../hooks/userAccess";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageUserDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { isView } = usePermission({
    label: "Manage Users",
    page_permission: "isView",
  });

  const [valueTabs, setValueTabs] = useState(0);
  const [valueTabs1, setValueTabs1] = useState(0);
  const [valueTabs2, setValueTabs2] = useState(0);

  const { data: userRes } = useGetUsersByIdQuery(
    id ? { id } : ({ id: "" } as any),
    { skip: !id }
  );
  const { data: userTransactions } = useGetUserTransactionsQuery(
    id
      ? {
          id,
          page: 1,
          limit: 10,
          search: "",
          dateFrom: "",
          dateTo: "",
        }
      : ({ id: "" } as any),
    { skip: !id }
  );

  // Calculate loyalty points statistics from API data
  const calculateLoyaltyStats = () => {
    const transactions =
      userTransactions?.data?.transactionData ||
      userTransactions?.data?.list ||
      [];

    if (!transactions.length) {
      return {
        totalPoints: 0,
        totalEarned: 0,
        totalRedeemed: 0,
        totalExpired: 0,
        totalInProcess: 0,
      };
    }

    let totalEarned = 0;
    let totalRedeemed = 0;
    let totalExpired = 0;
    let totalInProcess = 0;
    transactions.forEach((transaction: any) => {
      const entryType = String(transaction.entryType || "").toLowerCase();
      const points = Number(transaction.points || 0);
      const expiredPoints = Number(transaction.expiredPoints || 0);

      if (
        entryType.includes("sale") ||
        entryType.includes("earn") ||
        entryType.includes("positive")
      ) {
        totalEarned += Math.max(points, 0);
      } else if (
        entryType.includes("redeem") ||
        entryType.includes("negative")
      ) {
        totalRedeemed += Math.abs(points);
      } else if (entryType.includes("expire")) {
        totalExpired += Math.max(expiredPoints, Math.abs(points));
      } else {
        totalInProcess += Math.abs(points);
      }
    });

    const totalPoints = totalEarned - totalRedeemed - totalExpired;

    return {
      totalPoints: Math.max(0, totalPoints),
      totalEarned,
      totalRedeemed,
      totalExpired,
      totalInProcess,
    };
  };

  const loyaltyStats = calculateLoyaltyStats();

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs2(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="main_title">
        <h1>User Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate(-1)}>Manage Users</button> - User
          Detail
        </p>
      </div>

      {isView && (
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                className="custom_tabs_links"
              >
                <Tab label="Personal Info" {...a11yProps(0)} />
                <Tab label="Loyalty Points" {...a11yProps(1)} />
                <Tab label="Account Activity" {...a11yProps(2)} />
                <Tab label="Feedback & Rating" {...a11yProps(3)} />
              </Tabs>
            </Box>
          </div>
        </div>
      )}

      {/* Personal Info */}
      {isView && (
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="table_header">
              <h2>Personal Info</h2>
              {/* <div className="right_s">
              <Button className="btn btn_primary sm" onClick={() => setOpenModal(true)}>Resend Verification</Button>
            </div> */}
            </div>
            <div className="gap_p">
              <div className="w_33">
                <h6>Full Name</h6>
                <p>{userRes?.data?.fullName || ""}</p>
              </div>
              <div className="w_33">
                <h6>Email</h6>
                <p>{userRes?.data?.email || ""}</p>
              </div>
              <div className="w_33">
                <h6>Phone</h6>
                <p>
                  {`${userRes?.data?.dialCode || ""} ${
                    userRes?.data?.phoneNo || ""
                  }`}
                  {/* <img src="/static/images/tick_icon.svg" alt="verified" />  */}
                </p>
              </div>
              <div className="w_33">
                <h6>Date Registered</h6>
                <p>
                  {userRes?.data?.createdAt
                    ? dayjs(userRes?.data?.createdAt).format("DD-MM-YYYY")
                    : "--"}
                </p>
              </div>
              <div className="w_33">
                <h6>DOB</h6>
                <p>
                  {userRes?.data?.dateOfBirth
                    ? dayjs(userRes?.data?.dateOfBirth).format("DD-MM-YYYY")
                    : "--"}
                </p>
              </div>
              <div className="w_33">
                <h6>Member Account</h6>
                <p>{userRes?.data?.memberAccount || ""}</p>
              </div>
              <div className="w_33">
                <h6>Membership Card</h6>
                <p>{userRes?.data?.membershipCard || "-"}</p>
              </div>
            </div>
          </div>
        </CustomTabPanel>
      )}

      {/* Loyalty Points */}
      {isView && (
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <div className="table_header">
              <div className="left_s">
                <div className="section_title">
                  <h2>
                    Redeemable Points -{" "}
                    <span className="c_primary">
                      {userRes?.data?.transactionDetails?.totalIssuedPoints ||
                        0}
                    </span>
                  </h2>
                </div>
              </div>
            </div>

            <div className="stats_boxes v2 gap_m">
              <div className="cards">
                <h2>
                  {" "}
                  {userRes?.data?.transactionDetails?.redeemablePoints || 0}
                </h2>
                <p>Remaining Redeemable Points</p>
              </div>
              <div className="cards">
                <h2>
                  {" "}
                  {userRes?.data?.transactionDetails?.totalIssuedPoints || 0}
                </h2>
                <p>Total Earned</p>
              </div>
              <div className="cards">
                <h2>
                  {" "}
                  {userRes?.data?.transactionDetails?.totalUsedPoints || 0}
                </h2>
                <p>Redeemed</p>
              </div>
              <div className="cards">
                <h2>
                  {" "}
                  {userRes?.data?.transactionDetails?.totalExpiredPoints || 0}
                </h2>
                <p>Expired</p>
              </div>
              <div className="cards">
                <h2>
                  {" "}
                  {userRes?.data?.transactionDetails?.unRedeemablePoints || 0}
                </h2>
                <p>In-Process</p>
              </div>
            </div>
          </div>

          <div className="cards mt_20">
            <Box className="custom_tabs">
              <Tabs
                value={valueTabs1}
                onChange={handleChangeTabs1}
                className="custom_tabs_links"
              >
                <Tab label="Transaction history" {...a11yProps(0)} />
                <Tab label="Referral points history" {...a11yProps(1)} />
                {/* <Tab label="Adjusted Points By Admin" {...a11yProps(2)} /> */}
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs1} index={0}>
              <TransactionHistory hideUserColumn />
            </CustomTabPanel>

            <CustomTabPanel value={valueTabs1} index={1}>
              <ReferralHistory />
            </CustomTabPanel>

            <CustomTabPanel value={valueTabs1} index={2}>
              <AdjustedPointsTable />
            </CustomTabPanel>
          </div>
        </CustomTabPanel>
      )}

      {/* Account Activity */}
      {isView && (
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="cards">
            <Box className="custom_tabs">
              <Tabs
                value={valueTabs2}
                onChange={handleChangeTabs2}
                className="custom_tabs_links"
              >
                <Tab label="Login History" {...a11yProps(0)} />
                {/* <Tab label="Audit Log History" {...a11yProps(1)} /> */}
              </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs2} index={0}>
              <LoginHistory userId={id || ""} />
            </CustomTabPanel>
            {/* <CustomTabPanel value={valueTabs2} index={1}>
              <UserAuditLogTable />
            </CustomTabPanel> */}
          </div>
        </CustomTabPanel>
      )}

      {isView && (
        <CustomTabPanel value={valueTabs} index={3}>
          <div className="cards">
            <PromotionFeedbackTable showUserColumn={false} />
          </div>
        </CustomTabPanel>
      )}

      <VerificationModal
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageUserDetail;
